import { LoginView, MenuView } from "Store/User/reducer";

export type UserAction =
  | { type: 'CLEAR_LOGIN_INPUT' }
  | { type: 'CLEAR_COUNTRY_LIST' }
  | { type: 'SET_IS_FETCHING_USER', isFetching: boolean }
  | { type: 'SET_IS_FETCHING_ORDERS', isFetching: boolean }
  | { type: 'SET_MENU_VIEW', menuView: MenuView, error?: string }
  | { type: 'SET_LOGIN_VIEW', loginView: LoginView, error?: string }
  | { type: 'SET_LOGIN_EMAIL', email: string }
  | { type: 'SET_LOGIN_PASSWORD', password: string }
  | { type: 'SET_IS_LOGIN_USER', isLoginUser: boolean, email?: string }
  | { type: 'SET_COUNTRY_LIST', countryList: Julius.Website.CountryItemViewModel[] }
  | { type: 'SET_ORDERS', orders: Julius.Website.OrderSmallViewModel[] }
  | { type: 'SET_NEWSLETTER_STATUS', isSuccess: boolean, email: string }
  | { 
    type: 'SET_LOGGED_IN_USER', 
    user: Julius.Website.CustomerInfoViewModel, 
    nextMenuView?: MenuView, 
    nextLoginView?: LoginView,
  };

export const setIsFetchingUser = (isFetching: boolean): UserAction => ({
  isFetching,
  type: 'SET_IS_FETCHING_USER',
});

export const setIsFetchingOrders = (isFetching: boolean): UserAction => ({
  isFetching,
  type: 'SET_IS_FETCHING_ORDERS',
});

export const setMenuView = (menuView: MenuView, error?: string): UserAction => ({
  menuView,
  error,
  type: 'SET_MENU_VIEW',
});

export const setLoginView = (loginView: LoginView, error?: string): UserAction => ({
  loginView,
  error,
  type: 'SET_LOGIN_VIEW',
});

export const setUser = (
  user: Julius.Website.CustomerInfoViewModel, 
  nextMenuView?: MenuView, 
  nextLoginView?: LoginView,
  ): UserAction => ({
  user,
  nextMenuView,
  nextLoginView,
  type: 'SET_LOGGED_IN_USER',
});

export const setLoginEmail = (email: string): UserAction => ({
  email,
  type: 'SET_LOGIN_EMAIL',
});

export const setLoginPassword = (password: string): UserAction => ({
  password,
  type: 'SET_LOGIN_PASSWORD',
});

export const setIsLoginUser = (isLoginUser: boolean, email?: string): UserAction => ({
  isLoginUser, email,
  type: 'SET_IS_LOGIN_USER',
});

export const clearLogin = (): UserAction => ({
  type: 'CLEAR_LOGIN_INPUT',
});

export const setCountryList = (countryList: Julius.Website.CountryItemViewModel[]): UserAction => ({
  countryList,
  type: 'SET_COUNTRY_LIST',
});

export const clearCountryList = (): UserAction => ({
  type: 'CLEAR_COUNTRY_LIST',
});

export const setOrderHistory = (orders: Julius.Website.OrderSmallViewModel[]): UserAction => ({
  orders,
  type: 'SET_ORDERS',
});

export const setNewsletterStatus = (isSuccess: boolean, email: string): UserAction => ({
  isSuccess,
  email,
  type: 'SET_NEWSLETTER_STATUS',
});


// WEBPACK FOOTER //
// ./src/store/User/actions.tsx